export default {
  GROUP_FILES: 'GROUP_FILES'
}
